import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// PWA install is intentionally OFF. Owner clarified: this would let
// other people install an app that points at the OWNER's backend/data,
// not a private personal copy. Reverted until we build proper
// multi-tenant. Also unregister any previously-installed worker so old
// sessions stop launching from a cached shell.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => { /* ignore */ });
}
